import React, { useEffect, useRef, useState } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import "./home.css";
import cloudVideo from "../../../assets/video/cloud_video.mp4";
import drone from "../../../assets/images/drone.png";
import DroneSection from "../DroneSection/DroneSection";
import Header from "../../shared/header/header";
import { useSelector } from "react-redux";

const Home = () => {
  const sectionRef = useRef(null);

  const { scrollYProgress } = useScroll({
    target: sectionRef,
    offset: ["start start", "end start"],
  }); 
  
  // Drone flies up and fades
  const droneY = useTransform(scrollYProgress, [0, 0.5], ["0vh", "-100vh"]);
  const droneOpacity = useTransform(scrollYProgress, [0, 0.8], [1, 0]);

  // Text slides and fades
  const leftTextX = useTransform(scrollYProgress, [0.2, 0.6], [0, -300]);
  const rightTextX = useTransform(scrollYProgress, [0.2, 0.6], [0, 300]);
  const textOpacity = useTransform(scrollYProgress, [0, 0.4], [1, 0]);

  const homeData = useSelector((store) => store.data.HomeData);
  const [data,setData] = useState(null)
  useEffect(()=>{
    homeData?.items.forEach((ele)=>{
        if(ele.Section == 'Heading'){
          setData(ele?.Content)
          // console.log(ele?.Content)
        }
    })
  },[homeData, data]);

  return (
    <div>
      {/* Section 1: Home */}
      <div className="scroll-stack">
        <div ref={sectionRef} className="main-container">
          <div className="video-bg">
            <video autoPlay muted loop playsInline>
              <source src={cloudVideo} type="video/mp4" />
            </video>
          </div>

          <div className="home-container">
            {/* Header Removed — will be reused as a shared component */}
            <Header />

            <div className="home-content">
              <div className="heading-container">
                <motion.h1
                  className="heading"
                  initial={{ x: -300, opacity: 0 }}
                  animate={{ x: 0, opacity: 1 }}
                  transition={{ duration: 1 }}
                  style={{ x: leftTextX, opacity: textOpacity }}
                >
                { data?.FirstLine ? data?.FirstLine : 'Hyper Local Drone' } 
                </motion.h1>

                <motion.h1
                  className="heading"
                  initial={{ x: 300, opacity: 0 }}
                  animate={{ x: 0, opacity: 1 }}
                  transition={{ duration: 1 }}
                  style={{ x: rightTextX, opacity: textOpacity }}
                >
                 { data?.SecondLine ? data?.SecondLine : 'Delivery Network' } 
                </motion.h1>
              </div>
              <div>
                <motion.img
                  src={drone}
                  alt="Flying Drone"
                  className="shared-drone"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ duration: 1.2 }}
                  style={{
                    y: droneY,
                    opacity: droneOpacity,
                  }}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="drone-section-container">
          <DroneSection dronename={drone} />
        </div>
      </div>
      {/* <div style={{ height: "300vh" }}></div> */}
    </div>
  );
};

export default Home;
